import axios from "axios";
import { tmsApi } from "../api";

export const getDashboardCount = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + "v1/services/capturedashboard/cards/count", body, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

export const getBookingbyUser = async (body) => {
  const config = {
    headers: {
      token: `${localStorage.getItem("token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(
        tmsApi + `v1/services/capturedashboard/booking/history`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getContributions = async (body) => {
  const config = {
    headers: {
      token: `localStorage.getItem("token")`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .post(tmsApi + `v1/services/capturedashboard/booking/graph`, body, config)
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};
